<template lang="html">
  <div
    :style="`background-image: url('${resolvedBackground ? resolvedBackground.columns.file.url : ''}');`"
    class="related-content-tile"
  >
    <div class="related-content-tile__overlay">
      <slot />
    </div>
  </div>
</template>

<script>
import { Resource } from 'beisheim/models'
export default {
  props: {
    background: {
      type: String,
      default: undefined,
    }
  },
  computed: {
    resolvedBackground () {
      return this.background && Resource.find(this.background)
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/scale';
@import 'beisheim/scss/grid';
@import 'beisheim/scss/breakpoints';

$component: '.related-content-tile';

#{$component} {
  height: scale(80);
  background-size: cover;
  background-position: center center;

  @include from(4) {
    height: 50vw;
    width: 50vw;
    max-height: $max-width / 2;
  }

  &__overlay {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    width: 100%;
    height: 100%;
    background-color: rgba(51, 51, 51, 0.7);
    @include grid-spacing(padding-left, 2);
    @include grid-spacing(padding-right, 2);
  }
}
</style>
